import * as React from "react";
const SvgFiRrUserSalary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M11 0C7.691 0 5 2.691 5 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m2.969 5.501a1 1 0 0 1-1.218.719A7 7 0 0 0 11 16c-3.859 0-7 3.14-7 7a1 1 0 1 1-2 0c0-4.962 4.037-9 9-9 .761 0 1.518.095 2.249.284a1 1 0 0 1 .72 1.217M24 19c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1.002h-.27a3.01 3.01 0 0 1-2.596-1.496 1 1 0 0 1 1.73-1.003c.179.308.51.499.866.499L21 20a1 1 0 0 0 .999-1 .77.77 0 0 0-.644-.76l-3.041-.507A2.76 2.76 0 0 1 15.999 15c0-1.654 1.346-3 3-3v-1a1 1 0 1 1 2 0v1.003h.271c1.063 0 2.058.573 2.594 1.495a1 1 0 1 1-1.728 1.005 1 1 0 0 0-.866-.5L18.999 14A1 1 0 0 0 18 15c0 .378.271.698.644.76l3.041.507A2.76 2.76 0 0 1 24 19"
    />
  </svg>
);
export default SvgFiRrUserSalary;
